var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Version } from "../../../types";
import { CardV1 } from "./CardV1";
import { CardV2 } from "./CardV2";
export const Card = (_a) => {
    var { version = Version.v2 } = _a, rest = __rest(_a, ["version"]);
    switch (version) {
        case Version.v1:
            return (_jsx(CardV1, Object.assign({}, rest)));
        case Version.v2:
            return (_jsx(CardV2, Object.assign({}, rest)));
        default:
            return (_jsx(CardV1, Object.assign({}, rest)));
    }
};
//# sourceMappingURL=Card.js.map